/**
 * Back in Stock Notification Modal
 * 再入荷通知モーダルの管理
 */

(function () {
  // Constants
  const ANIMATION_DURATION = 300;
  const CSS_CLASSES = {
    ACTIVE: "is-active",
    CLOSING: "is-closing",
    HIDDEN: "is-hidden",
    ALERT: "bis-alert",
    ALERT_DANGER: "bis-alert-danger",
  };

  const MESSAGES = {
    EMAIL_REQUIRED: "メールアドレスを入力してください",
    GENERAL_ERROR:
      "エラーが発生しました。しばらく待ってから再度お試しください。",
    NETWORK_ERROR:
      "通信エラーが発生しました。しばらく待ってから再度お試しください。",
    REGISTRATION_FAILED: "通知の登録に失敗しました。",
    SERVICE_UNAVAILABLE:
      "サービスが準備中です。しばらく待ってから再度お試しください。",
    SENDING: "送信中...",
    SUBMIT_BUTTON_TEXT: "登録",
    MODAL_TEMPLATE_NOT_FOUND: "モーダルテンプレートが見つかりません。",
    DOM_ERROR: "DOM操作エラーが発生しました。",
    INVALID_PRODUCT_ID: "無効な商品IDです。",
  };

  /**
   * DOM要素を取得するヘルパー関数
   * data属性ベースのみ使用
   */
  const getElements = function (productId) {
    // フォールバック検索付きの要素取得関数
    const getByDataAttr = function (selector) {
      var result;

      // パターン1: data-product-idコンテナ内での検索
      result = document.querySelector(
        '[data-product-id="' + productId + '"] ' + selector
      );
      if (result) {
        return result;
      }

      // パターン2: セレクタ自体にdata-product-idが付く場合
      result = document.querySelector(
        selector + '[data-product-id="' + productId + '"]'
      );
      if (result) {
        return result;
      }

      // パターン3: IDベースでのフォールバック検索
      var idSelector = selector
        .replace(/\[data-field="([^"]+)"\]/g, "#bis-$1-" + productId)
        .replace(/\[data-area="([^"]+)"\]/g, "#bis-$1-area-" + productId)
        .replace(/\[data-action="([^"]+)"\]/g, "#bis-$1-btn-" + productId);

      if (idSelector !== selector) {
        result = document.querySelector(idSelector);
        if (result) {
          return result;
        }
      }

      // パターン4: クラス名ベースでのフォールバック検索
      var classSelector = selector
        .replace(/\[data-field="([^"]+)"\]/g, ".bis-$1")
        .replace(/\[data-area="([^"]+)"\]/g, ".bis-$1-area")
        .replace(/\[data-action="([^"]+)"\]/g, ".bis-$1-btn");

      if (classSelector !== selector) {
        var modal = document.querySelector(
          '.bis-modal-overlay[data-product-id="' + productId + '"]'
        );
        if (modal) {
          result = modal.querySelector(classSelector);
          if (result) {
            return result;
          }
        }
      }

      return null;
    };

    var elements = {
      modal: document.querySelector(
        '.bis-modal-overlay[data-product-id="' + productId + '"]'
      ),
      email: getByDataAttr('[data-field="email"]'),
      submitBtn: getByDataAttr('[data-action="submit"]'),
      messageHolder: getByDataAttr('[data-area="messages"]'),
      completedMessage: getByDataAttr('[data-area="completed"]'),
      form: document.querySelector(
        '.bis-form[data-product-id="' + productId + '"]'
      ),
      inputArea: getByDataAttr('[data-area="input"]'),
      successArea: getByDataAttr('[data-area="success"]'),
      alreadyRegisteredArea: getByDataAttr('[data-area="already-registered"]'),
      emailDisplay: getByDataAttr('[data-field="email-display"]'),
      emailDisplayRegistered: getByDataAttr(
        '[data-field="email-display-registered"]'
      ),
    };

    return elements;
  };

  /**
   * フォームリセット関数
   */
  const resetBisForm = function (productId) {
    const elements = getElements(productId);

    if (elements.inputArea && elements.successArea) {
      elements.inputArea.classList.remove(CSS_CLASSES.HIDDEN);
      elements.successArea.classList.add(CSS_CLASSES.HIDDEN);
    }
  };

  /**
   * エラーメッセージを表示
   */
  const showError = (messageHolder, message) => {
    messageHolder.innerHTML = `<div class="${CSS_CLASSES.ALERT} ${CSS_CLASSES.ALERT_DANGER}">${message}</div>`;
  };

  /**
   * ボタンの状態を更新
   */
  const updateButtonState = (button, disabled, text) => {
    button.disabled = disabled;
    button.textContent = text;
  };

  /**
   * 成功時の処理
   */
  const handleSuccess = function (elements, productId) {
    console.log("=== Handle Success ===");

    // 1. アクティブモーダルから最新のメールアドレスを取得
    var emailValue = "";
    var activeModal =
      document.querySelector(
        '.bis-modal-overlay.is-active[data-product-id="' + productId + '"]'
      ) ||
      document.querySelector(
        '.bis-modal-overlay[data-product-id="' + productId + '"]'
      );

    if (activeModal) {
      var activeEmailInput = activeModal.querySelector(
        'input[type="email"], input[name="email"], [data-field="email"]'
      );
      if (activeEmailInput && activeEmailInput.value) {
        emailValue = activeEmailInput.value.trim();
      }
    }

    // フォールバック: 元の要素から取得
    if (!emailValue && elements.email && elements.email.value) {
      emailValue = elements.email.value.trim();
    }

    console.log("Success email value:", emailValue);

    // 2. アクティブモーダル内の要素を直接操作
    if (activeModal) {
      var activeInputArea = activeModal.querySelector('[data-area="input"]');
      var activeSuccessArea = activeModal.querySelector(
        '[data-area="success"]'
      );
      var activeEmailDisplay = activeSuccessArea
        ? activeSuccessArea.querySelector('[data-field="email-display"]')
        : null;
      var messageHolder = activeModal.querySelector('[data-area="messages"]');

      console.log("Active success area found:", !!activeSuccessArea);

      if (activeInputArea && activeSuccessArea) {
        // 入力エリアは表示したまま（隠さない）

        // 成功エリアを表示
        activeSuccessArea.classList.remove(CSS_CLASSES.HIDDEN);

        // メールアドレスを成功エリアに設定
        if (activeEmailDisplay) {
          activeEmailDisplay.textContent = emailValue;
          console.log("Set success email display:", emailValue);
        }

        // エラー表示をクリア
        if (messageHolder) {
          messageHolder.innerHTML = "";
        }

        console.log("Success area displayed in active modal");
      } else {
        console.warn("Success area elements not found in active modal");
      }
    } else {
      console.warn("Active modal not found for success display");
    }

    console.log("=== Handle Success Complete ===");
  };

  /**
   * エラーレスポンスからメッセージを構築
   */
  const buildErrorMessage = (response) => {
    if (!response) {
      return MESSAGES.GENERAL_ERROR;
    }

    // エラーメッセージの優先順位：
    // 1. response.message（APIからの明示的なメッセージ）
    // 2. response.errors（詳細エラー情報）
    // 3. デフォルトエラーメッセージ

    if (response.message) {
      // 既存登録のチェック（パターンを拡張）
      var message = response.message.toLowerCase();
      if (
        message.includes("既に登録") ||
        message.includes("すでに登録") ||
        message.includes("already registered") ||
        message.includes("already subscribed") ||
        message.includes("already exists") ||
        message.includes("duplicate") ||
        message.includes("重複")
      ) {
        return "このメールアドレスは既に登録されています。";
      }
      return response.message;
    }

    if (response.errors) {
      const errorMessages = [];

      // エラーオブジェクトを解析
      if (typeof response.errors === "object") {
        Object.keys(response.errors).forEach((key) => {
          const error = response.errors[key];
          if (Array.isArray(error)) {
            errorMessages.push(...error);
          } else if (typeof error === "string") {
            errorMessages.push(error);
          }
        });
      }

      if (errorMessages.length > 0) {
        const combinedMessage = errorMessages.join(" ");
        // 既存登録のチェック（パターンを拡張）
        var lowerMessage = combinedMessage.toLowerCase();
        if (
          lowerMessage.includes("既に登録") ||
          lowerMessage.includes("すでに登録") ||
          lowerMessage.includes("already registered") ||
          lowerMessage.includes("already subscribed") ||
          lowerMessage.includes("already exists") ||
          lowerMessage.includes("duplicate") ||
          lowerMessage.includes("重複")
        ) {
          return "このメールアドレスは既に登録されています。";
        }
        return combinedMessage;
      }
    }

    return MESSAGES.GENERAL_ERROR;
  };

  /**
   * Back in Stock Modal (Singleton Function Pattern)
   */
  function BackInStockModal() {
    // シングルトンパターン実装
    if (BackInStockModal.instance) {
      return BackInStockModal.instance;
    }

    // プライベート状態
    const state = {
      activeModal: null,
      templates: new Map(),
      eventHandlers: new Map(),
      eventDelegationSetup: false,
    };

    // プライベートメソッド
    function initEventDelegation() {
      if (state.eventDelegationSetup) return;

      // 単一の委譲イベントリスナーを document に設定
      const handleDelegatedClick = function (event) {
        // 表示トリガーのチェック
        const triggerBtn = event.target.closest("[data-bis-trigger]");
        if (triggerBtn) {
          event.preventDefault();
          const productId = triggerBtn.getAttribute("data-bis-trigger");
          if (productId) {
            instance.show(productId);
          }
          return;
        }

        // 閉じるボタンのチェック
        const closeBtn = event.target.closest("[data-bis-close]");
        if (closeBtn) {
          event.preventDefault();
          event.stopPropagation();
          const productId = closeBtn.getAttribute("data-bis-close");
          if (productId) {
            instance.close(productId);
          }
          return;
        }

        // モーダル外側クリックのチェック
        const modalOverlay = event.target.closest(".bis-modal-overlay");
        if (modalOverlay && event.target === modalOverlay) {
          const productId = modalOverlay.getAttribute("data-product-id");
          if (productId) {
            instance.close(productId);
          }
        }
      };

      // フォーム送信の委譲処理
      const handleDelegatedSubmit = function (event) {
        const form = event.target.closest(".bis-form");
        if (form) {
          event.preventDefault();
          const productId = form.getAttribute("data-product-id");
          let variantId = form.getAttribute("data-variant-id");

          // バリアントIDがフォームにない場合は、submitボタンから取得
          if (!variantId) {
            const submitBtn = form.querySelector("[data-variant-id]");
            if (submitBtn) {
              variantId = submitBtn.getAttribute("data-variant-id");
            }
          }

          if (productId && variantId) {
            instance.submit(productId, variantId);
          }
        }
      };

      document.addEventListener("click", handleDelegatedClick);
      document.addEventListener("submit", handleDelegatedSubmit);

      // イベントハンドラーを保存
      state.eventHandlers.set("delegatedClick", handleDelegatedClick);
      state.eventHandlers.set("delegatedSubmit", handleDelegatedSubmit);

      state.eventDelegationSetup = true;
    }

    // パブリックメソッドを定義するインスタンス
    const instance = {
      /**
       * 商品IDでモーダルを検索（data属性のみ）
       */
      findModalByProductId: function (productId) {
        // data属性ベースでの検索のみ
        return document.querySelector(
          '.bis-modal-overlay[data-product-id="' + productId + '"]'
        );
      },

      /**
       * 複数要素の検索・フィルタリング
       */
      findAllModalsByProductId: function (productId) {
        // data属性ベースのみ
        const nodeList = document.querySelectorAll(
          '.bis-modal-overlay[data-product-id="' + productId + '"]'
        );
        const modals = [];
        for (let i = 0; i < nodeList.length; i++) {
          modals.push(nodeList[i]);
        }
        return modals;
      },

      /**
       * テンプレートを取得し、キャッシュに保存
       */
      getTemplate: function (productId) {
        // 1. キャッシュから取得を試行
        if (state.templates.has(productId)) {
          const cached = state.templates.get(productId);
          // テンプレートが DOM に存在するか確認
          if (document.contains(cached)) {
            return cached;
          } else {
            // キャッシュが無効な場合は削除
            state.templates.delete(productId);
          }
        }

        // 2. DOM から検索
        const modal = this.findModalByProductId(productId);

        if (!modal) {
          // フォールバック: getElementsを使用
          const elements = getElements(productId);
          if (elements.modal) {
            // キャッシュに保存
            state.templates.set(productId, elements.modal);
            return elements.modal;
          }

          console.error("No modal template found for product ID:", productId);
          return null;
        }

        // 3. テンプレートキャッシング（元テンプレート保護）
        if (!state.templates.has(productId)) {
          state.templates.set(productId, modal);
        }

        return modal;
      },

      /**
       * 元テンプレート保護のために、body直下以外のモーダルを取得
       */
      _getOriginalModal: function (productId) {
        return this.getTemplate(productId);
      },

      /**
       * 表示用クローンを作成・管理
       */
      _createDisplayClone: function (originalModal, productId) {
        const clone = originalModal.cloneNode(true);

        // 重要: data-product-id属性を確実に設定
        clone.setAttribute("data-product-id", productId);

        // クローンにマーカーを追加して識別可能にする
        clone.setAttribute("data-is-clone", "true");
        clone.setAttribute("data-created-at", Date.now().toString());

        // classも確実に設定
        if (!clone.classList.contains("bis-modal-overlay")) {
          clone.classList.add("bis-modal-overlay");
        }

        return clone;
      },

      /**
       * 元テンプレートかどうかを判定
       */
      _isOriginalTemplate: function (modal) {
        // body直下でない、かつクローンマーカーがない
        return (
          modal.parentNode !== document.body &&
          !modal.hasAttribute("data-is-clone")
        );
      },

      /**
       * 個別モーダルのイベントリスナーを設定（互換性のため）
       */
      _setupEventListeners: function (modal, productId) {
        const self = this;

        // イベント委譲が有効な場合は、追加のリスナーは不要
        if (state.eventDelegationSetup) {
          // data属性を設定してイベント委譲で処理されるようにする
          const closeBtn = modal.querySelector(".bis-close-btn");
          if (closeBtn) {
            closeBtn.removeAttribute("onclick");
            closeBtn.setAttribute("data-bis-close", productId);
          }
          return;
        }

        // フォールバック: 従来の個別イベントリスナー
        const handleOutsideClick = function (event) {
          if (event.target === modal) {
            self.close(productId);
          }
        };
        modal.addEventListener("click", handleOutsideClick);
        modal._handleOutsideClick = handleOutsideClick;

        const closeBtn = modal.querySelector(".bis-close-btn");
        if (closeBtn) {
          closeBtn.removeAttribute("onclick");
          const handleCloseClick = function (event) {
            event.preventDefault();
            event.stopPropagation();
            self.close(productId);
          };
          closeBtn.addEventListener("click", handleCloseClick);
          closeBtn._handleCloseClick = handleCloseClick;
        }
      },

      /**
       * 全てのアクティブモーダルを閉じる（排他制御）
       */
      closeAllModals: function () {
        // 全てのアクティブなモーダルを検索
        const activeModals = document.querySelectorAll(
          ".bis-modal-overlay.is-active"
        );

        for (let i = 0; i < activeModals.length; i++) {
          const modal = activeModals[i];
          if (modal.parentNode === document.body) {
            modal.classList.remove("is-active");
            modal.classList.add("is-closing");

            (function (m) {
              setTimeout(function () {
                if (m.parentNode === document.body) {
                  m.remove();
                }
              }, ANIMATION_DURATION);
            })(modal);
          }
        }

        // 状態をリセット
        state.activeModal = null;
        document.body.style.overflow = "";
      },

      /**
       * ライフサイクルメソッド: 初期化
       */
      init: function () {
        if (!state.eventDelegationSetup) {
          initEventDelegation();
        }
        return this;
      },

      /**
       * ライフサイクルメソッド: 破棄
       */
      destroy: function () {
        // 全モーダルを閉じる
        this.closeAllModals();

        // イベントリスナーを削除
        state.eventHandlers.forEach(function (handler, type) {
          if (type === "delegatedClick") {
            document.removeEventListener("click", handler);
          } else if (type === "delegatedSubmit") {
            document.removeEventListener("submit", handler);
          }
        });

        // 状態をリセット
        state.eventHandlers.clear();
        state.templates.clear();
        state.activeModal = null;
        state.eventDelegationSetup = false;

        return this;
      },

      /**
       * 状態管理: アクティブモーダル取得
       */
      getActiveModal: function () {
        return state.activeModal;
      },

      /**
       * 状態管理: キャッシュされたテンプレート数
       */
      getTemplateCount: function () {
        return state.templates.size;
      },

      /**
       * 状態管理: イベントハンドラー数
       */
      getEventHandlerCount: function () {
        return state.eventHandlers.size;
      },

      /**
       * 状態管理: システム状態の取得
       */
      getState: function () {
        return {
          activeModal: !!state.activeModal,
          templateCount: this.getTemplateCount(),
          eventHandlerCount: this.getEventHandlerCount(),
          eventDelegationSetup: state.eventDelegationSetup,
        };
      },

      /**
       * メモリリーク防止: 不要なテンプレートキャッシュを削除
       */
      cleanupTemplates: function () {
        const toDelete = [];

        state.templates.forEach(function (template, productId) {
          // DOM に存在しないテンプレートをマーク
          if (!document.contains(template)) {
            toDelete.push(productId);
          }
        });

        // 不要なキャッシュを削除
        for (let i = 0; i < toDelete.length; i++) {
          state.templates.delete(toDelete[i]);
        }

        return toDelete.length;
      },

      /**
       * エラー種別の分類
       */
      _getErrorType: function (error) {
        if (error.name === "TypeError" && error.message.indexOf("DOM") !== -1) {
          return "DOM_ERROR";
        }
        if (
          error.name === "NetworkError" ||
          error.message.indexOf("fetch") !== -1
        ) {
          return "NETWORK_ERROR";
        }
        if (
          error.message.indexOf("template") !== -1 ||
          error.message.indexOf("modal") !== -1
        ) {
          return "TEMPLATE_ERROR";
        }
        return "GENERAL_ERROR";
      },

      /**
       * 包括的なエラーハンドリング
       */
      _handleError: function (context, error, productId) {
        const self = this;
        const errorType = this._getErrorType(error);

        console.error("[BIS Error - " + context + "]:", error);

        // エラー統計（開発環境のみ）
        if (
          typeof window !== "undefined" &&
          window.location &&
          window.location.hostname === "localhost"
        ) {
          console.warn("Error details:", {
            context: context,
            type: errorType,
            productId: productId,
            stack: error.stack,
            timestamp: new Date().toISOString(),
          });
        }

        // グレースフルデグラデーション
        try {
          switch (context) {
            case "MODAL_SHOW":
              this._handleModalShowError(error, productId);
              break;
            case "MODAL_CLOSE":
              this._handleModalCloseError(error, productId);
              break;
            case "TEMPLATE_LOAD":
              this._handleTemplateError(error, productId);
              break;
            case "FORM_SUBMIT":
              this._handleFormSubmitError(error, productId);
              break;
            default:
              this._handleGeneralError(error);
          }
        } catch (recoveryError) {
          console.error("[BIS Recovery Error]:", recoveryError);
          this._handleCriticalError(recoveryError);
        }
      },

      /**
       * モーダル表示エラーのリカバリ
       */
      _handleModalShowError: function (error, productId) {
        const self = this;
        // 全モーダルを安全に閉じる
        try {
          this.closeAllModals();
        } catch (e) {
          console.warn("Could not close modals during error recovery:", e);
        }

        // ユーザーに通知
        this._notifyUser(MESSAGES.MODAL_TEMPLATE_NOT_FOUND);
      },

      /**
       * モーダル閉じるエラーのリカバリ
       */
      _handleModalCloseError: function (error, productId) {
        // 強制的にbodyスタイルを復元
        try {
          document.body.style.overflow = "";
          state.activeModal = null;
        } catch (e) {
          console.warn("Could not restore body style:", e);
        }
      },

      /**
       * テンプレートエラーのリカバリ
       */
      _handleTemplateError: function (error, productId) {
        // キャッシュをクリア
        if (productId) {
          state.templates.delete(productId);
        }

        this._notifyUser(MESSAGES.MODAL_TEMPLATE_NOT_FOUND);
      },

      /**
       * フォーム送信エラーのリカバリ
       */
      _handleFormSubmitError: function (error, productId) {
        if (productId) {
          const elements = getElements(productId);
          if (elements.submitBtn) {
            updateButtonState(
              elements.submitBtn,
              false,
              MESSAGES.SUBMIT_BUTTON_TEXT
            );
          }
          if (elements.messageHolder) {
            showError(elements.messageHolder, MESSAGES.GENERAL_ERROR);
          }
        }
      },

      /**
       * 一般エラーのリカバリ
       */
      _handleGeneralError: function (error) {
        console.error("[BIS General Error]:", error);
      },

      /**
       * 致命的エラーのリカバリ
       */
      _handleCriticalError: function (error) {
        const self = this;
        console.error("[BIS Critical Error]:", error);

        // システムを安全な状態にリセット
        try {
          this.destroy();
          this.init();
        } catch (e) {
          console.error("[BIS Reset Failed]:", e);
        }
      },

      /**
       * ユーザー通知
       */
      _notifyUser: function (message) {
        // 簡易的な通知（必要に応じてより高度な通知システムに置き換え）
        if (typeof window !== "undefined" && window.alert) {
          setTimeout(function () {
            window.alert(message);
          }, 100);
        }
      },

      /**
       * BISオブジェクトの待機処理
       */
      _waitForBIS: function (timeout, onSuccess, onError) {
        var self = this;
        timeout = timeout || 10000; // デフォルト10秒

        // 既に利用可能な場合は即座に成功コールバックを実行
        if (typeof BIS !== "undefined" && BIS.create) {
          if (onSuccess) onSuccess(BIS);
          return;
        }

        var startTime = Date.now();
        var checkInterval = 500; // 500ms間隔でチェック
        var checkCount = 0;

        var intervalId = setInterval(function () {
          checkCount++;
          var elapsed = Date.now() - startTime;

          // BISオブジェクトが利用可能になった場合
          if (typeof BIS !== "undefined" && BIS.create) {
            clearInterval(intervalId);
            console.log("[BIS Wait] BIS object found after " + elapsed + "ms");
            if (onSuccess) onSuccess(BIS);
            return;
          }

          // タイムアウトチェック
          if (elapsed >= timeout) {
            clearInterval(intervalId);
            console.warn("[BIS Wait] Timeout after " + elapsed + "ms");
            var error = new Error(
              "BIS object not available after " + timeout + "ms"
            );
            if (onError) onError(error);
            return;
          }
        }, checkInterval);
      },

      /**
       * モーダルを表示
       */
      show: function (productId) {
        const self = this;
        try {
          // 入力検証
          if (!productId) {
            throw new Error(MESSAGES.INVALID_PRODUCT_ID);
          }

          // 1. 排他制御: 既存のモーダルを全て閉じる
          this.closeAllModals();

          // 2. 元テンプレートを安全に取得
          const originalModal = this._getOriginalModal(productId);
          if (!originalModal) {
            throw new Error(
              "Modal template not found for product: " + productId
            );
          }

          // 3. 表示用クローンを作成（元テンプレート保護）
          const modal = this._createDisplayClone(originalModal, productId);

          // 4. 同一商品の既存表示モーダルのみ削除（元テンプレート保護）
          const existingModals = this.findAllModalsByProductId(productId);
          for (let i = 0; i < existingModals.length; i++) {
            const existing = existingModals[i];
            // 元テンプレートは保護し、表示用クローンのみ削除
            if (
              existing.parentNode === document.body &&
              !this._isOriginalTemplate(existing)
            ) {
              existing.remove();
            }
          }

          // 5. 表示処理
          document.body.appendChild(modal);
          resetBisForm(productId);
          modal.classList.add("is-active");
          document.body.style.overflow = "hidden";

          // 6. 状態管理
          state.activeModal = modal;
          this._setupEventListeners(modal, productId);
        } catch (error) {
          this._handleError("MODAL_SHOW", error, productId);
        }
      },

      /**
       * モーダルを閉じる
       */
      close: function (productId) {
        const self = this;
        try {
          // 新しい検索システムで表示中モーダルを取得
          const displayedModals = this.findAllModalsByProductId(productId);

          for (let i = 0; i < displayedModals.length; i++) {
            const modal = displayedModals[i];
            if (modal.parentNode === document.body) {
              modal.classList.remove("is-active");
              modal.classList.add("is-closing");

              (function (m) {
                setTimeout(function () {
                  if (m.parentNode === document.body) {
                    m.remove();
                  }
                }, ANIMATION_DURATION);
              })(modal);
            }
          }

          state.activeModal = null;
          document.body.style.overflow = "";
        } catch (error) {
          this._handleError("MODAL_CLOSE", error, productId);
        }
      },

      /**
       * フォームを送信
       */
      submit: function (productId, variantId) {
        const self = this;
        try {
          if (typeof event !== "undefined") {
            event.preventDefault();
          }

          // 入力検証
          if (!productId || !variantId) {
            throw new Error("Product ID or Variant ID is missing");
          }

          // 最新の要素を取得（フォーム送信時に確実に最新の値を取得）
          var elements = getElements(productId);
          if (!elements.submitBtn || !elements.messageHolder) {
            throw new Error("Required form elements not found");
          }

          // メールアドレスを動的取得（アクティブモーダルから優先取得）
          var email = "";

          console.log("=== Email Dynamic Retrieval Debug ===");

          // 方法1: アクティブモーダルから直接取得
          var activeModal =
            document.querySelector(
              '.bis-modal-overlay.is-active[data-product-id="' +
                productId +
                '"]'
            ) ||
            document.querySelector(
              '.bis-modal-overlay[data-product-id="' + productId + '"]'
            );

          if (activeModal) {
            console.log("Active modal found for email retrieval:", activeModal);
            var activeEmailInput = activeModal.querySelector(
              'input[type="email"], input[name="email"], [data-field="email"]'
            );
            if (activeEmailInput && activeEmailInput.value) {
              email = activeEmailInput.value.trim();
              console.log("Email retrieved from active modal:", email);
              // 要素参照も更新
              elements.email = activeEmailInput;
            } else {
              console.warn("Email input not found or empty in active modal");
            }
          } else {
            console.warn("Active modal not found for email retrieval");
          }

          // 方法2: getElementsで取得した要素から（フォールバック）
          if (!email && elements.email && elements.email.value) {
            email = elements.email.value.trim();
            console.log("Email retrieved from getElements (fallback):", email);
          }

          console.log("Final email for submission:", email);

          if (!email) {
            showError(elements.messageHolder, MESSAGES.EMAIL_REQUIRED);
            return;
          }

          console.log("=== Form Submission Debug ===");
          console.log("Email being submitted:", email);

          updateButtonState(elements.submitBtn, true, MESSAGES.SENDING);
          elements.messageHolder.innerHTML = "";

          // エラー・成功エリアを一度リセット（アクティブモーダル内）
          if (activeModal) {
            var resetSuccessArea = activeModal.querySelector(
              '[data-area="success"]'
            );
            var resetAlreadyRegisteredArea = activeModal.querySelector(
              '[data-area="already-registered"]'
            );

            if (resetSuccessArea) {
              resetSuccessArea.classList.add(CSS_CLASSES.HIDDEN);
              console.log("Reset success area to hidden");
            }

            if (resetAlreadyRegisteredArea) {
              resetAlreadyRegisteredArea.classList.add(CSS_CLASSES.HIDDEN);
              console.log("Reset already registered area to hidden");
            }
          }

          // BISオブジェクト待機処理を使用
          this._waitForBIS(
            10000,
            function (bisObject) {
              console.log(
                "BIS object ready, calling create with email:",
                email
              );
              self._callBisCreate(email, variantId, productId, elements);
            },
            function (error) {
              console.error("BIS object wait timeout:", error);
              showError(elements.messageHolder, MESSAGES.SERVICE_UNAVAILABLE);
              updateButtonState(
                elements.submitBtn,
                false,
                MESSAGES.SUBMIT_BUTTON_TEXT
              );
            }
          );
        } catch (error) {
          this._handleError("FORM_SUBMIT", error, productId);
        }
      },

      /**
       * BIS.createを呼び出す（Promise対応）
       */
      _callBisCreate: function (email, variantId, productId, elements) {
        const self = this;
        try {
          console.log("=== BIS.create Call Debug ===");
          console.log("Calling BIS.create with email:", email);
          console.log("Variant ID:", variantId);
          console.log("Product ID:", productId);

          const result = BIS.create(email, variantId, productId);
          console.log("BIS.create response:", result);

          if (result && typeof result.then === "function") {
            // Promiseの場合
            const promise = result.then(function (response) {
              console.log(
                "BIS.create Promise resolved with response:",
                response
              );
              self._handleBisResponse(response, elements, productId);
            });

            if (promise && typeof promise.catch === "function") {
              promise.catch(function (error) {
                console.error("BIS.create promise error:", error);
                self._handleError("FORM_SUBMIT", error, productId);
              });
            }
          } else {
            // 同期的にレスポンスを返す場合
            console.log("BIS.create returned synchronous response:", result);
            this._handleBisResponse(result, elements, productId);
          }
        } catch (error) {
          console.error("BIS.create error:", error);
          throw error;
        }
      },

      /**
       * BISレスポンスを処理
       */
      _handleBisResponse: function (response, elements, productId) {
        console.log("=== BIS Response Handler Debug ===");
        console.log("Response received:", response);
        console.log(
          "Response status:",
          response ? response.status : "undefined"
        );
        console.log(
          "Response errors:",
          response ? response.errors : "undefined"
        );

        if (response && response.status === "OK") {
          console.log("Success response - handling success");
          handleSuccess(elements, productId);
        } else {
          console.log("Error response - building error message");
          const errorMessage = buildErrorMessage(response);
          console.log("Built error message:", errorMessage);

          // 既存登録エラーの場合は専用エリアを表示
          if (
            errorMessage.includes("このメールアドレスは既に登録されています")
          ) {
            console.log("Already registered error - showing dedicated area");
            this._showAlreadyRegisteredArea(elements, productId);
          } else if (elements.messageHolder) {
            showError(elements.messageHolder, errorMessage);
          } else {
            const freshElements = getElements(productId);
            if (freshElements.messageHolder) {
              showError(freshElements.messageHolder, errorMessage);
            } else {
              // 最後の手段：モーダル内を直接検索
              var modal = document.querySelector(
                '.bis-modal-overlay[data-product-id="' + productId + '"]'
              );
              if (modal) {
                var messageHolders = modal.querySelectorAll(
                  '.bis-message-holder, [data-area="messages"], .bis-error-area'
                );
                if (messageHolders.length > 0) {
                  showError(messageHolders[0], errorMessage);
                } else {
                  // 最終フォールバック：alertで表示
                  setTimeout(function () {
                    if (typeof window !== "undefined" && window.alert) {
                      window.alert("エラー: " + errorMessage);
                    }
                  }, 100);
                }
              }
            }
          }
        }

        updateButtonState(
          elements.submitBtn,
          false,
          MESSAGES.SUBMIT_BUTTON_TEXT
        );
      },

      /**
       * 既存登録エラー専用エリアを表示
       */
      _showAlreadyRegisteredArea: function (elements, productId) {
        console.log("=== Show Already Registered Area ===");

        // 1. 最新の要素を再取得
        var freshElements = getElements(productId);

        // 2. 入力されたメールアドレスを取得（アクティブモーダルから優先取得）
        var emailValue = "";

        // まずアクティブモーダルから取得を試行
        var currentActiveModal =
          document.querySelector(
            '.bis-modal-overlay.is-active[data-product-id="' + productId + '"]'
          ) ||
          document.querySelector(
            '.bis-modal-overlay[data-product-id="' + productId + '"]'
          );

        if (currentActiveModal) {
          var currentActiveEmailInput = currentActiveModal.querySelector(
            'input[type="email"], input[name="email"], [data-field="email"]'
          );
          if (currentActiveEmailInput && currentActiveEmailInput.value) {
            emailValue = currentActiveEmailInput.value.trim();
          }
        }

        // フォールバック: 通常の取得方法
        if (!emailValue) {
          if (freshElements.email && freshElements.email.value) {
            emailValue = freshElements.email.value.trim();
          } else if (elements.email && elements.email.value) {
            emailValue = elements.email.value.trim();
          }
        }

        // 3. 使用する要素を決定
        var inputArea = freshElements.inputArea || elements.inputArea;
        var alreadyRegisteredArea = freshElements.alreadyRegisteredArea;
        var messageHolder =
          freshElements.messageHolder || elements.messageHolder;

        // 4. 代替検索
        if (!alreadyRegisteredArea) {
          var modal = document.querySelector(
            '.bis-modal-overlay[data-product-id="' + productId + '"]'
          );
          if (modal) {
            var selectors = [
              '[data-area="already-registered"]',
              ".bis-already-registered-area",
              '.bis-already-registered-area[data-product-id="' +
                productId +
                '"]',
            ];

            for (var i = 0; i < selectors.length; i++) {
              alreadyRegisteredArea = modal.querySelector(selectors[i]);
              if (alreadyRegisteredArea) {
                break;
              }
            }
          }
        }

        if (!inputArea || !alreadyRegisteredArea) {
          // フォールバック: 通常のエラー表示
          if (messageHolder) {
            showError(
              messageHolder,
              "このメールアドレスは既に登録されています。"
            );
          }
          return;
        }

        // 6. メールアドレス設定はアクティブモーダル操作時に実行

        // 7. エリア切り替え（実際に表示されているモーダル内の要素を直接操作）
        console.log("Switching to already registered area...");

        // 表示中のモーダルを確実に取得
        var activeModal = document.querySelector(
          '.bis-modal-overlay.is-active[data-product-id="' + productId + '"]'
        );
        if (!activeModal) {
          activeModal = document.querySelector(
            '.bis-modal-overlay[data-product-id="' + productId + '"]'
          );
        }

        if (activeModal) {
          // アクティブモーダル内の要素を直接操作
          var activeInputArea = activeModal.querySelector(
            '[data-area="input"]'
          );
          var activeAlreadyRegisteredArea = activeModal.querySelector(
            '[data-area="already-registered"]'
          );

          if (activeInputArea && activeAlreadyRegisteredArea) {
            // 入力エリアは表示したまま（隠さない）

            // 既存登録エリアを表示
            activeAlreadyRegisteredArea.classList.remove(CSS_CLASSES.HIDDEN);

            // メールアドレスを設定（アクティブモーダル内の最新値を取得）
            var activeEmailDisplay = activeAlreadyRegisteredArea.querySelector(
              '[data-field="email-display-registered"]'
            );
            if (activeEmailDisplay) {
              // アクティブモーダル内の入力欄から最新の値を取得
              var activeEmailInput = activeModal.querySelector(
                'input[type="email"], input[name="email"], [data-field="email"]'
              );
              var latestEmailValue = "";

              if (activeEmailInput && activeEmailInput.value) {
                latestEmailValue = activeEmailInput.value.trim();
              } else {
                latestEmailValue = emailValue; // フォールバック
              }

              activeEmailDisplay.textContent = latestEmailValue;
              console.log(
                "Set email display in active modal:",
                latestEmailValue
              );
            }

            // 成功: アクティブモーダルでの操作完了
            alreadyRegisteredArea = activeAlreadyRegisteredArea;
          } else {
            // フォールバック: 既存登録エリアのみ表示（入力エリアは隠さない）
            alreadyRegisteredArea.classList.remove(CSS_CLASSES.HIDDEN);
          }
        } else {
          // フォールバック: 既存登録エリアのみ表示（入力エリアは隠さない）
          alreadyRegisteredArea.classList.remove(CSS_CLASSES.HIDDEN);
        }

        // 8. エラー表示をクリア
        if (messageHolder) {
          messageHolder.innerHTML = "";
        }

        console.log("=== Show Already Registered Area Complete ===");
      },
    };

    // イベント委譲システムを初期化
    initEventDelegation();

    // インスタンスをシングルトンとして保存
    BackInStockModal.instance = instance;

    return instance;
  }

  // Factory関数でシングルトンインスタンスを作成
  BackInStockModal.getInstance = function () {
    if (!BackInStockModal.instance) {
      BackInStockModal.instance = new BackInStockModal();
    }
    return BackInStockModal.instance;
  };

  // シングルトンインスタンスを作成
  const BisModal = BackInStockModal.getInstance();

  // グローバルに公開
  window.BisModal = BisModal;
  window.BackInStockModal = BackInStockModal;

  // 後方互換性のためのグローバル関数（完全互換）
  window.showBisModal = function (productId) {
    try {
      return BisModal.show(productId);
    } catch (error) {
      console.error("showBisModal error:", error);
      // フォールバック処理
      const modal = document.getElementById("bis-modal-" + productId);
      if (modal) {
        modal.classList.add("is-active");
        document.body.style.overflow = "hidden";
      }
    }
  };

  window.closeBisModal = function (productId) {
    try {
      return BisModal.close(productId);
    } catch (error) {
      console.error("closeBisModal error:", error);
      // フォールバック処理
      const modal = document.getElementById("bis-modal-" + productId);
      if (modal) {
        modal.classList.remove("is-active");
        document.body.style.overflow = "";
      }
    }
  };

  window.submitBisForm = function (productId, variantId) {
    try {
      return BisModal.submit(productId, variantId);
    } catch (error) {
      console.error("submitBisForm error:", error);
      // フォールバック処理は submit 内で処理済み
    }
  };

  // 後方互換性: 既存のCSS クラス名サポート
  // 追加のユーティリティ関数
  window.resetBisForm = resetBisForm;

  // 後方互換性: 既存のヘルパー関数へのアクセス
  window.BisModal.utils = {
    getElements: getElements,
    showError: showError,
    updateButtonState: updateButtonState,
    handleSuccess: handleSuccess,
    buildErrorMessage: buildErrorMessage,
  };

  // 後方互換性: 定数へのアクセス
  window.BisModal.constants = {
    CSS_CLASSES: CSS_CLASSES,
    MESSAGES: MESSAGES,
    ANIMATION_DURATION: ANIMATION_DURATION,
  };

  // デバッグ用：状態確認関数
  window.BisModal.debug = function () {
    const modals = document.querySelectorAll(".bis-modal-overlay");
    console.log("Total modals found:", modals.length);
    for (let i = 0; i < modals.length; i++) {
      console.log("Modal " + i + ":", {
        "data-product-id": modals[i].getAttribute("data-product-id"),
        "data-is-clone": modals[i].getAttribute("data-is-clone"),
        parent: modals[i].parentNode.tagName,
        classes: modals[i].className,
      });
    }
  };

  // is-hiddenクラス制御の手動デバッグ関数
  window.BisModal.debugAlreadyRegisteredArea = function (productId) {
    console.log("=== Manual Already Registered Area Debug ===");
    console.log("Product ID:", productId);

    var elements = getElements(productId);
    var alreadyRegisteredArea = elements.alreadyRegisteredArea;

    if (!alreadyRegisteredArea) {
      console.error(
        "Already registered area not found for product:",
        productId
      );
      return false;
    }

    console.log("Element:", alreadyRegisteredArea);
    console.log("Classes:", alreadyRegisteredArea.className);
    console.log(
      "Has is-hidden:",
      alreadyRegisteredArea.classList.contains("is-hidden")
    );
    console.log("Style attribute:", alreadyRegisteredArea.style.cssText);

    if (typeof window !== "undefined" && window.getComputedStyle) {
      var computedStyle = window.getComputedStyle(alreadyRegisteredArea);
      console.log("Computed display:", computedStyle.display);
      console.log("Computed visibility:", computedStyle.visibility);
    }

    // 手動で is-hidden を除去
    console.log("Manually removing is-hidden class...");
    alreadyRegisteredArea.classList.remove("is-hidden");
    console.log("Classes after removal:", alreadyRegisteredArea.className);

    // 強制スタイル適用
    console.log("Manually applying styles...");
    alreadyRegisteredArea.style.display = "flex";
    alreadyRegisteredArea.style.visibility = "visible";
    console.log(
      "Style attribute after manual apply:",
      alreadyRegisteredArea.style.cssText
    );

    return true;
  };
})();
